import { Stack } from '@mui/joy';
import { ICellRendererParams } from 'ag-grid-community';

import { ExpandableList } from 'core/components';
import { DEFAULT_PLACEHOLDER } from 'core/constants';
import { TextLine } from 'core/elements';
import { IProgramProject } from 'projects/types';

import { IExternalCustomerRow, MAX_DISPLAYED_PAIRED_PROJECTS } from './utils';

interface IProps extends ICellRendererParams<IExternalCustomerRow> {
  pairedProjectField: keyof Pick<IProgramProject, 'projectName' | 'projectNumber'>;
}

export const PairedProjectsCell = ({ data, value, pairedProjectField }: IProps) => {
  if (!data) {
    return value ?? DEFAULT_PLACEHOLDER;
  }

  const pairedProjects = data.pairedProjects ?? [];

  return (
    <Stack>
      <TextLine text={value || DEFAULT_PLACEHOLDER} />

      {pairedProjects.length > 0 && (
        <ExpandableList<IProgramProject>
          items={pairedProjects}
          itemRenderer={(pairedProject: IProgramProject) => (
            <TextLine text={pairedProject[pairedProjectField] || DEFAULT_PLACEHOLDER} isSubText />
          )}
          getItemKey={(pairedProject: IProgramProject) => pairedProject.id}
          marker=""
          maxItems={MAX_DISPLAYED_PAIRED_PROJECTS}
        />
      )}
    </Stack>
  );
};
